export default {
  h1: {
    fontSize: 35,
    fontWeight: 500,
    fontFamily: "Xirod",
  },
  h2: {
    fontSize: 30,
    fontWeight: 500,
    fontFamily:"'Orbitron', sans-serif",
  },
  h3: {
    fontSize: 27,
    fontWeight: 500,
    fontFamily: "Xirod",


  },
  h4: {
    fontSize: 20,
    fontWeight: 500,
    fontFamily: "URW Geometric",
  },
  h5: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: "'Mukta', sans-serif",
  },
  h6: {
    fontSize: 16,
    fontWeight: 500,
    fontFamily: "'Mukta', sans-serif",
  },
  body2: {
    fontSize: 14,
    fontFamily: "'Mukta', sans-serif",
  },
  body1: {
    fontSize: 16,
    fontFamily: "'Mukta', sans-serif",
  },
};
